import * as React from 'react';
import { observableValue } from '@vscode/observables';
import { viewWithModel, ViewModel, prop } from '@vscode/observables-react';
import { styles, mergeStyles } from './styles.js';

class TitleBarButtonModel extends ViewModel({
  active: prop<boolean>(),
}) {
  readonly isHovered = observableValue<boolean>(this, false);

  get active() { return this.props.active; }

  setHovered = (hovered: boolean): void => {
    this.isHovered.set(hovered, undefined);
  };
}

export const TitleBarButton = viewWithModel(
  TitleBarButtonModel,
  {
    onClick: prop.const<() => void>(),
    title: prop.const<string>(),
    children: prop.const<React.ReactNode>(),
  },
  (reader, model, props) => {
    const isHovered = model.isHovered.read(reader);
    const active = model.active.read(reader);

    const buttonStyle = mergeStyles(
      styles.titleBarButton,
      isHovered && !active && styles.titleBarButtonHover,
      active && styles.titleBarButtonActive,
    );

    return (
      <button
        style={buttonStyle}
        onClick={props.onClick}
        title={props.title}
        onMouseEnter={() => model.setHovered(true)}
        onMouseLeave={() => model.setHovered(false)}
      >
        {props.children}
      </button>
    );
  }
);
